import React, { useEffect } from 'react';

import { Form, Row, SubmitButton, useForm } from '../../../_lib/Form2';
import { ContentParagraph } from '../../../_lib/components/ContentParagraph';
import { ContentSelectComboBoxForForm2, ListBoxModifier } from '../../../components/molecules/Form/components/ComboBox';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import useRedirect from '../../../hooks/useRedirect';
import { translatePartOfStringWithLink } from '../../../lib/StringUtils/StringHTMLUtils';
import { SharedFilesMoveForm } from '../SharedFiles.types';

type SharedFilesSharedMoveForm = {
  form: SharedFilesMoveForm;
  selectedFiles?: string[];
  selectedDirectories?: string[];
  helpText?: string;
  submitButtonLabel: string;

  messageSuccess: string,
  messageSending: string
  messageFail: string,
  // for forward message
  messageSuccessTranslationKey: string
};

/**
 * Shared move Form for global and single item move.
 */
export function SharedFilesSharedMoveForm({
  form,
  selectedFiles,
  selectedDirectories,
  helpText,
  submitButtonLabel,
  messageSuccess,
  messageSending,
  messageFail,
  messageSuccessTranslationKey,
}: SharedFilesSharedMoveForm) {
  const { t } = useSonTranslation('SharedFiles');
  const [startRedirect] = useRedirect();

  const { formProps, params, fetchState } = useForm({ form: form });
  const fileParam = params.getByName('files');
  const dirParam = params.getByName('directories');

  const combobox = params.getByName('targetPageId');

  useEffect(() => {
    if (fetchState.type === 'success' && fetchState.response.data?.url) {
      startRedirect(fetchState.response.data.url);
    }
  }, [fetchState, startRedirect]);

  const getForwardMessage = () => {
    return fetchState.type === 'success'
      ? translatePartOfStringWithLink(messageSuccessTranslationKey, fetchState.response?.data?.url)
      : messageSuccess;
  };

  return (
    <Form {...formProps}>
      {helpText && (
        <Row>
          <ContentParagraph>{helpText}</ContentParagraph>
        </Row>
      )}

      {selectedFiles?.map(file => <input {...fileParam} value={file} key={file} />)}
      {selectedDirectories?.map(dir => <input {...dirParam} value={dir} key={dir} />)}
      <ContentSelectComboBoxForForm2
        name={combobox.name}
        suggestUrl={combobox.comboBoxUrl.url}
        modifierListBox={ListBoxModifier.RELATIVE} // listbox expands modal dialog
        labelTitle={t('forms.move.comboboxTitle')}
        labelHelpText={t('forms.move.comboboxHelp')}
        required={combobox.required}
      />
      <SubmitButton
        buttonLabel={submitButtonLabel}
        messageSuccess={getForwardMessage()}
        messageSending={messageSending}
        messageFail={messageFail}
        fetchState={fetchState}
      />
    </Form>
  );
}
